import * as React from "react";

const SvgGlobealt = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color}
      strokeWidth={2}
    >
      <path d="M21 12a9 9 0 0 1-9 9M21 12a9 9 0 0 0-9-9M21 12H3M12 21a9 9 0 0 1-9-9" />
      <path d="M12 21c1.657 0 3-4.03 3-9s-1.343-9-3-9M12 21c-1.657 0-3-4.03-3-9s1.343-9 3-9" />
      <path d="M3 12a9 9 0 0 1 9-9" />
    </g>
  </svg>
);

export default SvgGlobealt;
